'use client'

import { IPlace, useUpFetch } from '@repo/sdk'
import {
  Button,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
  Spinner,
} from '@repo/ui'
import { toast } from '@repo/ui'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useEffect, useState } from 'react'

interface Props {
  address: IPlace
  companyId?: number
  id: number
}

export const DeleteAddress = ({ companyId, id }: Props) => {
  const [open, setOpen] = useState(false)

  const queryClient = useQueryClient()
  const upFetch = useUpFetch()

  const {
    isPending: deletingAddress,
    mutate: deleteAddress,
    status,
  } = useMutation({
    mutationFn: async () => {
      return upFetch(`/companies/${companyId}/address-book/${id}`, {
        method: 'DELETE',
      })
    },
  })

  useEffect(() => {
    if (!deletingAddress && status === 'success') {
      queryClient.invalidateQueries({ queryKey: ['/companies/address-book'] })
      toast.success('Address deleted')
      setOpen(false)
    }
  }, [deletingAddress, status])

  return (
    <Dialog onOpenChange={setOpen} open={open}>
      <DialogTrigger asChild>
        <Button variant={'ghost'}>Delete</Button>
      </DialogTrigger>
      <DialogContent className={'z-[1401]'}>
        <DialogHeader>
          <DialogTitle>Are you absolutely sure?</DialogTitle>
          <DialogDescription>
            This action cannot be undone. Are you sure you want to permanently delete this address?
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button
            onClick={() => {
              setOpen(false)
            }}
            variant={'ghost'}
          >
            Cancel
          </Button>
          <Button
            onClick={() => {
              deleteAddress()
            }}
            variant={'destructive'}
          >
            {deletingAddress ? <Spinner /> : 'Delete'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
